import { Component, Input, OnChanges, SimpleChanges, DestroyRef, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { Assets } from '../../../oauth/models/headless-cms/Assets';
import { LoginPageResponse } from '../../../oauth/models/headless-cms/login-page-response';
import { LoginAds } from '../../../oauth/models/headless-cms/LoginAds';
import { LoginService } from '../../../core/services/login.service';
import { UtilsService } from '../../../core/services/utils';
import { LoginPageApiService } from '../../../core/services/login-page-api.service';
import { NgxHmCarouselModule } from 'ngx-hm-carousel';
import { GtUserGreetingComponent } from '../../../core/components/user-greeting/gt-user-greeting.component';
import { NgClass, NgIf, NgFor, UpperCasePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-sidebar',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['sidebar.component.scss'],
    imports: [NgClass, GtUserGreetingComponent, NgIf, NgxHmCarouselModule, NgFor, UpperCasePipe]
})
export class SidebarComponent implements  OnChanges {

  @Input()
  public loginChallenge;

  @Input()
  public domain;

  public slideInterval = 5000;
  public assets: Assets[];
  public loginResponse: LoginPageResponse;
  public messageProperties;
  public infinite = true;
  public autoplay = true;
  public configuredLoginTitle = '';
  public configuredLoginSubtitle = '';
  private defaultLoginTitle = 'Welcome to greytHR';
  private defaultLoginSubTitle = 'Streamline. Save Time. Better Clime';

  private destroyRef = inject(DestroyRef);

  constructor(private _loginService: LoginService,
    private _utils: UtilsService,
    private _loginPageApiService: LoginPageApiService) {
  }

  public loadAssets() {
    this._loginService.getLoginAds(this.loginChallenge, this.domain)
      .pipe(
        map((res: LoginAds[]) => res.map(({data}) => data)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((data) => {
        this.assets = data;
      });
  }

  public getImageSrc({image}): string {
    if (this._utils.isEmpty(image)) {
      return;
    }
    const [src] = image;
    return this._loginService.getAsset(src);
  }

  public ngOnChanges(changes: SimpleChanges) {

    if (!this._utils.isEmpty(changes.loginChallenge.currentValue) || !this._utils.isEmpty(changes.domain.currentValue)) {
      this.loadLoginPageRes();
    }
  }
  private loadLoginPageRes() {
    this._loginPageApiService.getLoginPage()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.loginResponse = res;
        this.messageProperties = this.preapareProperties(this.loginResponse.messageProperties);
        this.configuredLoginTitle = this.messageProperties.login_title ? this.messageProperties.login_title : this.defaultLoginTitle;
        this.configuredLoginSubtitle = this.messageProperties.login_subtitle ? this.messageProperties.login_subtitle : this.defaultLoginSubTitle;;
        if (!this.loginResponse.disableLoginPageCards) {
          this.loadAssets();
        }
      },(error)=>{
          console.error('error occurred while loading login page response ',error);
          this.configuredLoginTitle = this.defaultLoginTitle;
          this.configuredLoginSubtitle =  this.defaultLoginSubTitle;
      });
  }

  private preapareProperties(properties) {
    return properties.reduce((model, obj) => {
      const {key} = obj;
      const replacementKey = key.replace('.', '_');
      model[replacementKey] = obj.value;
      return {...model};
    }, {});
  }
}
